import React, {useEffect, useState} from 'react';
import {text} from '../text';
import {getUserAvatarCache, setUserAvatarCache, fetchImageAsDataUrl} from '../utils/userAvatarCache';

type Props = {
  userId?: string | number | null;
  photo?: string | null;
  name?: string | null;
  groupName?: string | null;
  imageBaseUrl: string;
};

export const UserAvatarCard: React.FC<Props> = ({userId, photo, name, groupName, imageBaseUrl}) => {
  const photoUrl = photo
    ? `${imageBaseUrl}/${photo}`.replace(/\\/g, '/').replace(/([^:])\/\/+/g, '$1/')
    : null;

  const [displaySrc, setDisplaySrc] = useState<string | null>(photoUrl);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);

    if (!userId || !photoUrl) {
      setDisplaySrc(photoUrl);
      return;
    }

    const cached = getUserAvatarCache(userId);
    if (cached && cached.photoDataUrl && cached.sourceUrl === photoUrl) {
      setDisplaySrc(cached.photoDataUrl);
      return;
    }

    setDisplaySrc(photoUrl);
    let cancelled = false;
    fetchImageAsDataUrl(photoUrl).then((dataUrl) => {
      if (cancelled || !dataUrl) return;
      setUserAvatarCache(userId, {
        photoDataUrl: dataUrl,
        sourceUrl: photoUrl,
        name: name || '',
        group_name: groupName || '',
      });
      setDisplaySrc(dataUrl);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, photoUrl]);

  return (
    <div style={{display: 'flex', alignItems: 'center', gap: 14, textTransform: 'capitalize'}}>
      {displaySrc && !imgError ? (
        <img
          src={displaySrc}
          alt={name || ''}
          style={{width: 50, height: 50, borderRadius: 25, objectFit: 'cover', flexShrink: 0}}
          onError={() => setImgError(true)}
        />
      ) : (
        <div
          style={{
            width: 50,
            height: 50,
            borderRadius: 25,
            backgroundColor: '#E0E0E0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 20,
            fontWeight: 'bold',
            color: '#757575',
            flexShrink: 0,
          }}
        >
          {name?.charAt(0) || '?'}
        </div>
      )}
      <div>
        <text.H4>{name || 'Unknown'}</text.H4>
        <text.T14 style={{color: '#9CA3AF'}}>{groupName || 'Unknown'}</text.T14>
      </div>
    </div>
  );
};
